import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// --- Globálny fetch wrapper ---
// Backend od 2026-08-05 vyžaduje token na všetkých /api/* endpointoch.
// Tento wrapper automaticky pridá Authorization hlavičku do každého /api volania,
// takže jednotlivé fetch() volania v App.js ju nemusia riešiť samy.
const _origFetch = window.fetch.bind(window);
window.fetch = function (input, init) {
  try {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.startsWith('/api/')) {
      const token = localStorage.getItem('nw_token');
      if (token) {
        init = init || {};
        const headers = new Headers(init.headers || (typeof input !== 'string' && input.headers) || undefined);
        if (!headers.has('Authorization')) {
          headers.set('Authorization', 'Bearer ' + token);
        }
        init.headers = headers;
      }
    }
  } catch (e) {
    // pri akejkoľvek chybe nechaj request prejsť v pôvodnej podobe
  }
  return _origFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
